<template>
  <div class="recommended-vacancies">
    <div class="recommended-vacancies__title">{{ $tMyVacancy('Recommended vacancies') }}</div>
      <RecommendedVacanciesList class="recommended-vacancies__list" />
  </div>
</template>

<script>
  import RecommendedVacanciesList from "../../components/RecommendedVacanciesList";

  export default {
    components: {
      RecommendedVacanciesList
    },
    data() {
      return {

      }
    },
    methods: {

    },
    created() {

    }
  }
</script>

<style lang="less">

</style>
